
const randomId = require('random-id');


export { randomId };